import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getAuthors = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/authors/', {
    params: {
      page,
      per_page: perPage,
      column: ((order || {}).column || ''),
      direction: ((order || {}).direction || 1),
      term
    }
  })
}

export const getAuthor = id => {
  return api.http.get(`/authors/${id}`)
}

export const searchAuthors = term => {
  return api.http.get('/authors/select_search', {
    params: {
      term
    }
  })
}

export const getSelectAuthors = (term, callback) => {
  searchAuthors(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteAuthor = id => {
  return api.http.delete(`/authors/${id}`)
}

export const restoreAuthor = id => {
  return api.http.put(`/authors/${id}/restore`)
}

export const editAuthor = (data, _id) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return api.http.put(`/authors/${_id}`, data, config)
}

export const addAuthor = data => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return api.http.post('/authors', data, config)
}



// WEBPACK FOOTER //
// ./src/api/authors.js